// The single authority for the model catalogue and the product default.
// Every "|| 'kimi'" fallback across the flows mirrors DEFAULT_MODEL — if the
// default ever changes again, change it here and sweep the fallbacks.
export const DEFAULT_MODEL = 'kimi';

// Grouped by provider for the cascading picker. Values are the backend's
// html_model identifiers; labels match the ones the questionnaires have
// always shown so nothing renames under the user.
export const MODEL_PROVIDERS = [
  {
    id: 'moonshot',
    label: 'Moonshot',
    // simple glyph badges — the CSP blocks external logo fetches
    badge: 'K',
    badgeClass: 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900',
    models: [
      { value: 'kimi', label: 'Kimi K3', desc: '1M context, Sonnet-class pricing — the default' },
    ],
  },
  {
    id: 'anthropic',
    label: 'Anthropic',
    badge: '✳',
    badgeClass: 'bg-orange-100 text-orange-600 dark:bg-orange-900/40 dark:text-orange-400',
    models: [
      { value: 'sonnet', label: 'Claude Sonnet 5', desc: 'Balanced: fast and high quality' },
      { value: 'opus', label: 'Claude Opus 5', desc: 'Highest quality, slower but more polished' },
    ],
  },
  {
    id: 'google',
    label: 'Google',
    badge: 'G',
    badgeClass: 'bg-blue-100 text-blue-600 dark:bg-blue-900/40 dark:text-blue-400',
    models: [
      { value: 'flash', label: 'Gemini 3 Flash', desc: 'Fast generation, great for iteration' },
      { value: 'pro', label: 'Gemini 3.1 Pro', desc: 'Vision-strong, great with design references' },
    ],
  },
  {
    id: 'openai',
    label: 'OpenAI',
    badge: '◎',
    badgeClass: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400',
    models: [
      { value: 'sol', label: 'GPT-5.6 Sol', desc: 'OpenAI flagship — premium tier' },
      { value: 'astra', label: 'GPT-6 Astra', desc: 'OpenAI frontier — Ultra tier, 2× Premium credits' },
    ],
  },
];

// The effective default: the user's saved preference when it names a real
// model, else the product default. Flow fallbacks call this instead of
// hardcoding, which is what makes the Settings "Default AI model" control
// real rather than decorative.
export const getDefaultModel = () => {
  try {
    const raw = localStorage.getItem('wizardly_prefs');
    if (raw) {
      const v = (JSON.parse(raw) || {}).defaultModel;
      if (v && MODEL_PROVIDERS.some((p) => p.models.some((m) => m.value === v))) {
        return v;
      }
    }
  } catch { /* fall through to the product default */ }
  return DEFAULT_MODEL;
};

export const findModel = (value) => {
  for (const p of MODEL_PROVIDERS) {
    const m = p.models.find((x) => x.value === value);
    if (m) return { ...m, provider: p };
  }
  return null;
};
